import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Value } from "../Value";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Values = /*#__PURE__*/memo(function (_ref) {
  var isDark = _ref.isDark,
    cardType = _ref.cardType,
    packages = _ref.packages,
    hasLabel = _ref.hasLabel;
  return packages.length > 0 ? /*#__PURE__*/React.createElement("ul", {
    className: cn('values', {
      'values--label': hasLabel
    }, cardType && "values--".concat(cardType)),
    "data-t-id": "components-Values"
  }, packages.map(function (packageItem) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('item'),
      key: packageItem.unit
    }, /*#__PURE__*/React.createElement(Value, {
      cardType: cardType,
      isDark: isDark,
      packageItem: packageItem
    }));
  })) : null;
});